import { parseDuration } from "../utils";

export const channelList = [
  {
    channelTitle: "سوپرمگاهیت",
    channelCover: "https://api.itunes.ir/itunes-public/img/playlist_cover/1738411170.jpg",
    channelTracks: [
      {
        title: "آدم سابق",
        duration: parseDuration("00:04:34"),
        singer: "رضا بهرام",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AdameSabeghRezaBahram.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AdameSabeghRezaBahram.mp3?host=dl.musiciom.ir",
      },
      {
        title: "آهنگ شب",
        duration: parseDuration("00:02:50"),
        singer: "اشوان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AhangeShabAshvan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AhangeShabAshvan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "آخرش قشنگه",
        duration: parseDuration("00:02:43"),
        singer: "علیرضا طلیسچی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AkhareshGhashangeAlirezaTalischi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AkhareshGhashangeAlirezaTalischi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عالیجناب",
        duration: parseDuration("00:03:34"),
        singer: "ایوان بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AlejenabIvanBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AlejenabIvanBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عاشقم کردی",
        duration: parseDuration("00:03:02"),
        singer: "هوروش بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AsheghamKardiHooroshBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AsheghamKardiHooroshBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عاشقانه",
        duration: parseDuration("00:03:51"),
        singer: "فرزاد فرزین",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AsheghaneFarzadFarzin.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AsheghaneFarzadFarzin.mp3?host=dl.musiciom.ir",
      },
      {
        title: "آتیش",
        duration: parseDuration("00:03:24"),
        singer: "فرزاد فرزین",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AtishFarzadFarzin.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AtishFarzadFarzin.mp3?host=dl.musiciom.ir",
      },
      {
        title: "آی ستاره",
        duration: parseDuration("00:02:35"),
        singer: "حامیم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AySetarehHaamim.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/AySetarehHaamim.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بگو چند",
        duration: parseDuration("00:02:34"),
        singer: "ناصر زینلی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BegoChandNaserZeynali.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BegoChandNaserZeynali.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بهت قول میدم",
        duration: parseDuration("00:03:37"),
        singer: "محسن یگانه",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BehetGholMidamMohsenYeganeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BehetGholMidamMohsenYeganeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بیا بازم",
        duration: parseDuration("00:03:23"),
        singer: "آرش و مسیح",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BiaBazamMasihandArash.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BiaBazamMasihandArash.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بی معرفت",
        duration: parseDuration("00:03:55"),
        singer: "بهنام بانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BiMarefatBehnamBani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BiMarefatBehnamBani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بن بست",
        duration: parseDuration("00:03:36"),
        singer: "اشوان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BonbastAshvan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BonbastAshvan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بوی شمال",
        duration: parseDuration("00:04:03"),
        singer: "آرش و مسیح",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BooyeShomalMasihandArash.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/BooyeShomalMasihandArash.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چتر خیس",
        duration: parseDuration("00:03:51"),
        singer: "حامد همایون",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ChatreKhisHamedHomayoun.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ChatreKhisHamedHomayoun.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چه حیف",
        duration: parseDuration("00:05:22"),
        singer: "معین زد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/CheHeyfMoeinZ.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/CheHeyfMoeinZ.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چشمات",
        duration: parseDuration("00:03:29"),
        singer: "فرزاد فرزین",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/CheshmatFarzadFarzin.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/CheshmatFarzadFarzin.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چشمون سیاه",
        duration: parseDuration("00:02:41"),
        singer: "ناصر زینلی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/CheshmoonSiahNaserZeynali.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/CheshmoonSiahNaserZeynali.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دیوونگی",
        duration: parseDuration("00:04:27"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DivoonegiSirvanKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DivoonegiSirvanKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دختر ایرونی",
        duration: parseDuration("00:02:52"),
        singer: "سهراب پاکزاد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DokhtarIrooniSohrabPakzad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DokhtarIrooniSohrabPakzad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دور از نفست",
        duration: parseDuration("00:03:33"),
        singer: "آرمان گرشاسبی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DoorAzNafasetArmanGarshasbi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DoorAzNafasetArmanGarshasbi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "درست نمیشم",
        duration: parseDuration("00:03:39"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DorostNemishamSirvanKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DorostNemishamSirvanKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دو تا دل عاشق",
        duration: parseDuration("00:02:55"),
        singer: "بهنام بانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DotaDeleAsheghBehnamBani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/DotaDeleAsheghBehnamBani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ای وای",
        duration: parseDuration("00:03:40"),
        singer: "بابک جهانبخش",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/EyVayBabakJahanbakhsh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/EyVayBabakJahanbakhsh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "گلوبند",
        duration: parseDuration("00:03:22"),
        singer: "عرفان طهماسبی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GeloobandErfanTahmasbi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GeloobandErfanTahmasbi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "قاب عکس خالی",
        duration: parseDuration("00:04:39"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhabeAkseKhaliSirvanKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhabeAkseKhaliSirvanKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "قاف",
        duration: parseDuration("00:03:23"),
        singer: "علیرضا طلیسچی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhafAlirezaTalischi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhafAlirezaTalischi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "قلب منی",
        duration: parseDuration("00:04:05"),
        singer: "حامیم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhalbeManiHaamim.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhalbeManiHaamim.mp3?host=dl.musiciom.ir",
      },
      {
        title: "قرص قمر",
        duration: parseDuration("00:03:02"),
        singer: "بهنام بانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhorseGhamarBehnamBani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GhorseGhamarBehnamBani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "گلی",
        duration: parseDuration("00:03:14"),
        singer: "آرش و مسیح",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GoliMasihandArash.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/GoliMasihandArash.mp3?host=dl.musiciom.ir",
      },
      {
        title: "هر بار این درو",
        duration: parseDuration("00:03:12"),
        singer: "ماکان بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/HarbarInDaroMacanBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/HarbarInDaroMacanBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "هیس",
        duration: parseDuration("00:03:12"),
        singer: "آصف آریا",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/HissAsefAria.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/HissAsefAria.mp3?host=dl.musiciom.ir",
      },
      {
        title: "جانم باش",
        duration: parseDuration("00:04:22"),
        singer: "آرون افشار",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/JanamBashAronAfshar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/JanamBashAronAfshar.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خنده هاتو قربون",
        duration: parseDuration("00:03:27"),
        singer: "آرون افشار",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhandehatoGhorboonAronAfshar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhandehatoGhorboonAronAfshar.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خجالتی",
        duration: parseDuration("00:02:16"),
        singer: "مجید رضوی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhejalatiMajidRazavi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhejalatiMajidRazavi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خودخواه",
        duration: parseDuration("00:04:11"),
        singer: "محسن یگانه",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhodkhahMohsenYeganeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhodkhahMohsenYeganeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خوشحالم",
        duration: parseDuration("00:03:10"),
        singer: "بهنام بانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhoshhalamBehnamBani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/KhoshhalamBehnamBani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "مغرور",
        duration: parseDuration("00:03:36"),
        singer: "اشوان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MaghrourAshvan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MaghrourAshvan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "مال منی",
        duration: parseDuration("00:04:23"),
        singer: "معین زد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MaleManiMoeinZ.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MaleManiMoeinZ.mp3?host=dl.musiciom.ir",
      },
      {
        title: "میرسه خبرا",
        duration: parseDuration("00:03:12"),
        singer: "علی یاسینی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MireseKhabaraAliYasini.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MireseKhabaraAliYasini.mp3?host=dl.musiciom.ir",
      },
      {
        title: "متاسفانه",
        duration: parseDuration("00:02:38"),
        singer: "مجید رضوی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MoteasefaneMajidRazavi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/MoteasefaneMajidRazavi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "نصفه شب",
        duration: parseDuration("00:02:26"),
        singer: "علی یاسینی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/NesfeShabAliYasini.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/NesfeShabAliYasini.mp3?host=dl.musiciom.ir",
      },
      {
        title: "اون روزا رو میخوام",
        duration: parseDuration("00:03:20"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/OonRoozaRoMikhamSirvanKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/OonRoozaRoMikhamSirvanKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "پا قدم",
        duration: parseDuration("00:02:06"),
        singer: "علیرضا طلیسچی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/PaghadamAlirezaTalischi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/PaghadamAlirezaTalischi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "رز سفید",
        duration: parseDuration("00:03:25"),
        singer: "حامیم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/RozeSefidHaamim.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/RozeSefidHaamim.mp3?host=dl.musiciom.ir",
      },
      {
        title: "سخت گیر",
        duration: parseDuration("00:03:17"),
        singer: "علیرضا طلیسچی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SakhtgirAlirezaTalischi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SakhtgirAlirezaTalischi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ستاره",
        duration: parseDuration("00:02:21"),
        singer: "مجید رضوی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SetarehMajidRazavi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SetarehMajidRazavi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شب عشق",
        duration: parseDuration("00:02:42"),
        singer: "بهنام بانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ShabeEshghBehnamBani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ShabeEshghBehnamBani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شب رویایی",
        duration: parseDuration("00:03:59"),
        singer: "آرون افشار",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ShabeRoyaeiAronAfshar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ShabeRoyaeiAronAfshar.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شیدا",
        duration: parseDuration("00:03:22"),
        singer: "اشوان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SheydaAshvan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SheydaAshvan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شوخی ندارم",
        duration: parseDuration("00:03:23"),
        singer: "سهراب پاکزاد و آصف آریا",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ShookhiNadaramSohrabPakzadandAsefAria.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ShookhiNadaramSohrabPakzadandAsefAria.mp3?host=dl.musiciom.ir",
      },
      {
        title: "سیاه سفید",
        duration: parseDuration("00:03:29"),
        singer: "حامیم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SiahSefidHaamim.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/SiahSefidHaamim.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تنها نزار",
        duration: parseDuration("00:03:55"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/TanhaNazarSirvanKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/TanhaNazarSirvanKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "زده بارون",
        duration: parseDuration("00:02:45"),
        singer: "مسعود صادقلو",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ZadeBaroonMasoudSadeghloo.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ZadeBaroonMasoudSadeghloo.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ذره ذره",
        duration: parseDuration("00:03:01"),
        singer: "اشوان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ZareZareAshvan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/supermegahit/ZareZareAshvan.mp3?host=dl.musiciom.ir",
      },
    ],
  },
  {
    channelTitle: "سنتی",
    channelCover: "https://api.itunes.ir/itunes-public/img/playlist_cover/1688467699.jpg",
    channelTracks: [
      {
        title: "اندک اندک",
        duration: parseDuration("00:04:23"),
        singer: "شهرام ناظری",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/AndakAndakShahramNazeri.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/AndakAndakShahramNazeri.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عزیز بشین به کنارم",
        duration: parseDuration("00:03:47"),
        singer: "روزبه نعمت اللهی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/AzizBeshinBeKenaromRoozbehNematollahi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/AzizBeshinBeKenaromRoozbehNematollahi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بله رویای عشق",
        duration: parseDuration("00:04:25"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/BaleRoyaeiEshghHomayounShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/BaleRoyaeiEshghHomayounShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بر من گذشتی",
        duration: parseDuration("00:03:14"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/BarManGozashtiHomayounShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/BarManGozashtiHomayounShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بارون",
        duration: parseDuration("00:04:30"),
        singer: "محمدرضا شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/BaroonMohammadrezaShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/BaroonMohammadrezaShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چرا از من رنجیده ای",
        duration: parseDuration("00:04:20"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/CheraAzManRanjideiHomayounShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/CheraAzManRanjideiHomayounShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دختر فال بین",
        duration: parseDuration("00:04:08"),
        singer: "علیرضا افتخاری",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/DokhtarakeFalbinAlirezaEftekhari.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/DokhtarakeFalbinAlirezaEftekhari.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دره دردانه",
        duration: parseDuration("00:03:37"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/DoreDordanehHomayounShajarian..jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/DoreDordanehHomayounShajarian..mp3?host=dl.musiciom.ir",
      },
      {
        title: "امشب اگر یاری کنی",
        duration: parseDuration("00:05:37"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/EmshabAgarYariKoniHomayounShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/EmshabAgarYariKoniHomayounShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "هم قفس",
        duration: parseDuration("00:04:03"),
        singer: "علیرضا قربانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/HamGhafasAlirezaGhorbani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/HamGhafasAlirezaGhorbani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "هوای گریه",
        duration: parseDuration("00:07:13"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/HavayeGeryehHomayounShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/HavayeGeryehHomayounShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "سریال امام علی",
        duration: parseDuration("00:06:19"),
        singer: "صدیق تعریف",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ImamAliSeriesSedigheTarif.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ImamAliSeriesSedigheTarif.mp3?host=dl.musiciom.ir",
      },
      {
        title: "کوه قاف",
        duration: parseDuration("00:03:37"),
        singer: "علی زنده وکیلی و مهران مدیری",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/KooheGhafAliZandVakiliandMehranModiri.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/KooheGhafAliZandVakiliandMehranModiri.mp3?host=dl.musiciom.ir",
      },
      {
        title: "مست عشق",
        duration: parseDuration("00:04:11"),
        singer: "علیرضا قربانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/MasteEshghAlirezaGhorbani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/MasteEshghAlirezaGhorbani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ناردونه",
        duration: parseDuration("00:09:00"),
        singer: "علی زنده وکیلی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/NardoonehAliZandVakili.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/NardoonehAliZandVakili.mp3?host=dl.musiciom.ir",
      },
      {
        title: "پرواز قوها",
        duration: parseDuration("00:03:30"),
        singer: "علیرضا قربانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ParvazeGhoohaAlirezaGhorbani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ParvazeGhoohaAlirezaGhorbani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "روزگار قریب",
        duration: parseDuration("00:06:36"),
        singer: "علیرضا قربانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/RoozegareGharibAlirezaGhorbani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/RoozegareGharibAlirezaGhorbani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شباهنگ",
        duration: parseDuration("00:07:27"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ShabahangHomayounShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ShabahangHomayounShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شعله ور",
        duration: parseDuration("00:03:49"),
        singer: "همایون شجریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/SholeVarHomayounShajarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/SholeVarHomayounShajarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "زیباترین رویا",
        duration: parseDuration("00:03:41"),
        singer: "علی زنده وکیل",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ZibatarinRoyaAliZandVakili.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/sonati/ZibatarinRoyaAliZandVakili.mp3?host=dl.musiciom.ir",
      },
    ],
  },
  {
    channelTitle: "پاپ روز",
    channelCover: "https://api.itunes.ir/itunes-public/img/playlist_cover/1737462323.jpg",
    channelTracks: [
      {
        title: "آهو",
        duration: parseDuration("00:04:37"),
        singer: "میثم ابراهیمی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/AhooMeysamEbrahimi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/AhooMeysamEbrahimi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عکس تو",
        duration: parseDuration("00:03:15"),
        singer: "گرشا رضایی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/AkseToGarshaRezaei.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/AkseToGarshaRezaei.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بچه",
        duration: parseDuration("00:03:30"),
        singer: "فرزاد فرزین",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BachehFarzadFarzin.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BachehFarzadFarzin.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بد کردی",
        duration: parseDuration("00:04:12"),
        singer: "مسعود صادقلو",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BadKardiMasoudSadeghloo.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BadKardiMasoudSadeghloo.mp3?host=dl.musiciom.ir",
      },
      {
        title: "برای تو",
        duration: parseDuration("00:03:05"),
        singer: "بابک مافی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BarayeToBabakMafi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BarayeToBabakMafi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بارون خیابونا رو می بنده",
        duration: parseDuration("00:03:27"),
        singer: "مسعود صادقلو",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BaroonKhiabonarMibandeEhsanKhajehAmiri.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BaroonKhiabonarMibandeEhsanKhajehAmiri.mp3?host=dl.musiciom.ir",
      },
      {
        title: "با تو اینم",
        duration: parseDuration("00:03:48"),
        singer: "حامیم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BaToInamHaamim.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BaToInamHaamim.mp3?host=dl.musiciom.ir",
      },
      {
        title: "به تو میرسه",
        duration: parseDuration("00:02:44"),
        singer: "آرمین زارعی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BeToMireseArminZareei.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BeToMireseArminZareei.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بغض",
        duration: parseDuration("00:03:05"),
        singer: "سینا درخشنده",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BoghzSinaDerakhshandeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/BoghzSinaDerakhshandeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چشم سیاه",
        duration: parseDuration("00:03:25"),
        singer: "میلاد بابایی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/CheshmSiyahMiladBabaei.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/CheshmSiyahMiladBabaei.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دختر ایرونی",
        duration: parseDuration("00:03:14"),
        singer: "سهراب پاکزاد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/DokhtarIrooniSohrabPakzad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/DokhtarIrooniSohrabPakzad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "گل پونه",
        duration: parseDuration("00:02:19"),
        singer: "علی عبدالمالکی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/GolePoonehAliAbdolmaleki.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/GolePoonehAliAbdolmaleki.mp3?host=dl.musiciom.ir",
      },
      {
        title: "گوشه به گوشه",
        duration: parseDuration("00:02:53"),
        singer: "سون باند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/GoosheBeGoosheSevenBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/GoosheBeGoosheSevenBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "جانان",
        duration: parseDuration("00:02:46"),
        singer: "حمید هیراد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/JananHamidHirad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/JananHamidHirad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خبر نداره",
        duration: parseDuration("00:02:23"),
        singer: "نوان بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/KhabarNadareNovanBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/KhabarNadareNovanBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "کی میدونه",
        duration: parseDuration("00:02:53"),
        singer: "مجید رضوی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/KiMidooneMajidRazavi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/KiMidooneMajidRazavi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عشق یعنی",
        duration: parseDuration("00:03:30"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/LoveIsXaniarKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/LoveIsXaniarKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "پسر خوب",
        duration: parseDuration("00:02:20"),
        singer: "محسن ابراهیم زاده",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/PesareKhoobMohsenEbrahimzadeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/PesareKhoobMohsenEbrahimzadeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شب چشمات",
        duration: parseDuration("00:02:57"),
        singer: "علی لهراسبی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/ShabeCheshmatAliLohrasbi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/ShabeCheshmatAliLohrasbi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "صبح",
        duration: parseDuration("00:02:35"),
        singer: "ماکان بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/SobhMacanBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/SobhMacanBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تقویم مچاله",
        duration: parseDuration("00:03:50"),
        singer: "محسن یگانه",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/TaghvimeMochalehMohsenYeganeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/TaghvimeMochalehMohsenYeganeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تله پاتی",
        duration: parseDuration("00:02:26"),
        singer: "نوان بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/TelepathyNovanBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/TelepathyNovanBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تیکه تیکه",
        duration: parseDuration("00:02:11"),
        singer: "هوروش بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/TikeTikeHoroushBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/TikeTikeHoroushBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "وقت پرواز",
        duration: parseDuration("00:03:19"),
        singer: "پازل بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/VaghteParvazPuzzleBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/VaghteParvazPuzzleBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "یه جور دیگه",
        duration: parseDuration("00:03:27"),
        singer: "بابک جهانبخش",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/YeJoorDigeBabakJahanbakhsh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/paprooz/YeJoorDigeBabakJahanbakhsh.mp3?host=dl.musiciom.ir",
      },
    ],
  },
  {
    channelTitle: "فیتنس",
    channelCover: "https://api.itunes.ir/itunes-public/img/playlist_cover/1737811593.jpg",
    channelTracks: [
      {
        title: "دودوتا چهارتا",
        duration: parseDuration("00:02:33"),
        singer: "پازل بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/22TA4TAPuzzleBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/22TA4TAPuzzleBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "علاقه خاص",
        duration: parseDuration("00:03:36"),
        singer: "بهنام بانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/AlagheyeKhasBehnamBani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/AlagheyeKhasBehnamBani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عاشقتم که",
        duration: parseDuration("00:03:43"),
        singer: "بابک جهانبخش",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/AsheghetamKeBabakJahanbakhsh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/AsheghetamKeBabakJahanbakhsh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "آی ستاره",
        duration: parseDuration("00:02:35"),
        singer: "حامیم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/AySetarehHaamim.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/AySetarehHaamim.mp3?host=dl.musiciom.ir",
      },
      {
        title: "برگرد",
        duration: parseDuration("00:04:27"),
        singer: "سهراب پاکزاد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/BargardSohrabPakzad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/BargardSohrabPakzad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بارون",
        duration: parseDuration("00:03:04"),
        singer: "بهنام بانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/BaroonBehnamBani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/BaroonBehnamBani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بهت گفتم",
        duration: parseDuration("00:03:18"),
        singer: "امیر عباس گلاب",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/BehetGoftamAmirabbasGolab.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/BehetGoftamAmirabbasGolab.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چشم مایی",
        duration: parseDuration("00:02:55"),
        singer: "ایوان بند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ChesheMayiEvanBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ChesheMayiEvanBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چشمات",
        duration: parseDuration("00:03:29"),
        singer: "فرزاد فرزین",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/CheshmatFarzadFarzin.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/CheshmatFarzadFarzin.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چشمون سیاه",
        duration: parseDuration("00:02:41"),
        singer: "ناصر زینلی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/CheshmoonSiyahNaserZeynali.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/CheshmoonSiyahNaserZeynali.mp3?host=dl.musiciom.ir",
      },
      {
        title: "چیه این عشق",
        duration: parseDuration("00:02:57"),
        singer: "آصف آریا",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ChiyeInEshghAsefAria.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ChiyeInEshghAsefAria.mp3?host=dl.musiciom.ir",
      },
      {
        title: "کد",
        duration: parseDuration("00:02:54"),
        singer: "میثم ابراهیمی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/CodeMeysamEbrahim.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/CodeMeysamEbrahim.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دیوونگی",
        duration: parseDuration("00:02:58"),
        singer: "حامد همایون",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/DivoonegiHamedHomayoun.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/DivoonegiHamedHomayoun.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دوست دارم",
        duration: parseDuration("00:03:22"),
        singer: "محسن یگانه",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/DoosetDaramMohsenYeganeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/DoosetDaramMohsenYeganeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ای جان ای جان",
        duration: parseDuration("00:02:50"),
        singer: "سینا درخشنده",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/EyjaneyjanSinaDerakhshandeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/EyjaneyjanSinaDerakhshandeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ژلوفن",
        duration: parseDuration("00:04:05"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GelofenXaniarKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GelofenXaniarKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "قاب عکس خالی",
        duration: parseDuration("00:04:39"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GhabeAkseKhaliSirvanKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GhabeAkseKhaliSirvanKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "غنیمت",
        duration: parseDuration("00:02:50"),
        singer: "ناصر زینلی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GhanimatNaserZeynali.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GhanimatNaserZeynali.mp3?host=dl.musiciom.ir",
      },
      {
        title: "گیسو پریشان",
        duration: parseDuration("00:03:14"),
        singer: "آرون افشار",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GisooParishanAronAfshar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/GisooParishanAronAfshar.mp3?host=dl.musiciom.ir",
      },
      {
        title: "همه شهر",
        duration: parseDuration("00:02:24"),
        singer: "آصف آریا",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/HameShahrAsefAria.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/HameShahrAsefAria.mp3?host=dl.musiciom.ir",
      },
      {
        title: "هوار هوار",
        duration: parseDuration("00:02:20"),
        singer: "علیرضا طلیسچی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/HavarHavarAlirezaTalischi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/HavarHavarAlirezaTalischi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "جنگل موهات",
        duration: parseDuration("00:03:03"),
        singer: "ناصر زینلی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/JangaleMoohatNaserZeynali.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/JangaleMoohatNaserZeynali.mp3?host=dl.musiciom.ir",
      },
      {
        title: "جذاب",
        duration: parseDuration("00:02:33"),
        singer: "سون باند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/JazzabSevenBand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/JazzabSevenBand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "جون",
        duration: parseDuration("00:02:54"),
        singer: "مسیح و آرش",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/JoonMasihandArash.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/JoonMasihandArash.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خجالت",
        duration: parseDuration("00:02:16"),
        singer: "مجید رضوی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/KhejalatiMajidRazavi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/KhejalatiMajidRazavi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "مال من باش",
        duration: parseDuration("00:03:57"),
        singer: "سهراب پاکزاد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/MaleManBashSohrabPakzad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/MaleManBashSohrabPakzad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "منو نگاه کن",
        duration: parseDuration("00:02:39"),
        singer: "حامد همایون",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ManoNegahKonHamedHomayoun.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ManoNegahKonHamedHomayoun.mp3?host=dl.musiciom.ir",
      },
      {
        title: "مثل تو",
        duration: parseDuration("00:03:22"),
        singer: "ماهان بهرام خان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/MeseToMahanBahramKhan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/MeseToMahanBahramKhan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عشق زیاد",
        duration: parseDuration("00:03:36"),
        singer: "فرزاد فرزین",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/MuchLoveFarzadFarzin.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/MuchLoveFarzadFarzin.mp3?host=dl.musiciom.ir",
      },
      {
        title: "نگاه آخر",
        duration: parseDuration("00:03:20"),
        singer: "مهدی جهانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/NegaheAkharMehdiJahani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/NegaheAkharMehdiJahani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "نصف شب",
        duration: parseDuration("00:02:26"),
        singer: "علی یاسینی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/NesfeShabAliYasini.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/NesfeShabAliYasini.mp3?host=dl.musiciom.ir",
      },
      {
        title: "طلا",
        duration: parseDuration("00:02:19"),
        singer: "مجید رضوی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/TalaMajidRazavi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/TalaMajidRazavi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تنها نزار",
        duration: parseDuration("00:03:55"),
        singer: "سیروان خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/TanhaNazarSirvanKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/TanhaNazarSirvanKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تو چه باشی",
        duration: parseDuration("00:03:39"),
        singer: "فرزاد فرزین",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ToCheBashiFarzadFarzin.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ToCheBashiFarzadFarzin.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تو یه دونه",
        duration: parseDuration("00:03:03"),
        singer: "آصف آریا",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ToYedooneAsefAria.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ToYedooneAsefAria.mp3?host=dl.musiciom.ir",
      },
      {
        title: "یاغی",
        duration: parseDuration("00:03:10"),
        singer: "سهراب پاکزاد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YaghiSohrabPakzad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YaghiSohrabPakzad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "یار نظر کرده",
        duration: parseDuration("00:03:28"),
        singer: "محمد علیزاده",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YarNazarKardeMohammadAlizadeh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YarNazarKardeMohammadAlizadeh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "یه امشب",
        duration: parseDuration("00:02:24"),
        singer: "مسیح و آرش",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YeEmshabMasihandArash.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YeEmshabMasihandArash.mp3?host=dl.musiciom.ir",
      },
      {
        title: "یه ستاره",
        duration: parseDuration("00:03:24"),
        singer: "زانیار خسروی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YeSetarehXaniarKhosravi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/YeSetarehXaniarKhosravi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "زلزله",
        duration: parseDuration("00:03:01"),
        singer: "آرون افشار",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ZelzelehAronAfshar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/fitnes/ZelzelehAronAfshar.mp3?host=dl.musiciom.ir",
      },
    ],
  },
  {
    channelTitle: "بی کلام",
    channelCover:
      "https://api.itunes.ir/itunes-public/img/playlist_cover/1732715636.jpeg",
    channelTracks: [
      {
        title: "آرام بخواب",
        duration: parseDuration("00:03:57"),
        singer: "بهنام خدارحمی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/AramBekhab-BehnamKhodarahmi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/AramBekhab-BehnamKhodarahmi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "آسوده و بی تشویش",
        duration: parseDuration("00:02:09"),
        singer: "نوید کیارزم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/AsoodeVaBiTashvish-NavidKiarazm.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/AsoodeVaBiTashvish-NavidKiarazm.mp3?host=dl.musiciom.ir",
      },
      {
        title: "برفراز",
        duration: parseDuration("00:03:00"),
        singer: "مازیار بازگیر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BarFaraz-MaziarBazgir.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BarFaraz-MaziarBazgir.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بدرود",
        duration: parseDuration("00:07:53"),
        singer: "امید آزادگان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/Bedrood-OmidAzadegan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/Bedrood-OmidAzadegan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "به یاد استاد لطف الله مجد",
        duration: parseDuration("00:04:45"),
        singer: "صائب کاکاوند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BeYadeOstadLotfollahMajdsaebKakavand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BeYadeOstadLotfollahMajdsaebKakavand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بی بال",
        duration: parseDuration("00:05:43"),
        singer: "حمیدرضا آفریده",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BiBal-HamidrezaAfarideh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BiBal-HamidrezaAfarideh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "بی بازگشت",
        duration: parseDuration("00:05:11"),
        singer: "فرامرز فنونی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BiBazgasht-FaramarzFonooni.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/BiBazgasht-FaramarzFonooni.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دلدار",
        duration: parseDuration("00:02:38"),
        singer: "مهدی وجدانی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/Deldar-MahdiVojdani.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/Deldar-MahdiVojdani.mp3?host=dl.musiciom.ir",
      },
      {
        title: "دوران کودکی",
        duration: parseDuration("00:03:27"),
        singer: "مهدی عطاریان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/DoraneKoodaki-MahdiAtarian.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/DoraneKoodaki-MahdiAtarian.mp3?host=dl.musiciom.ir",
      },
      {
        title: "انعکاس",
        duration: parseDuration("00:05:37"),
        singer: "فرامرز فنونی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/EnekasFaramarzFonouni.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/EnekasFaramarzFonouni.mp3?host=dl.musiciom.ir",
      },
      {
        title: "عیدانه ایرانی",
        duration: parseDuration("00:01:55"),
        singer: "علیرضا عباسی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/EydaneIraniAlirezaAbbasi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/EydaneIraniAlirezaAbbasi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "گذر زمان",
        duration: parseDuration("00:04:43"),
        singer: "امید آزادگان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/GozareZamanOmidAzadegan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/GozareZamanOmidAzadegan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "حدیث عشق",
        duration: parseDuration("00:04:05"),
        singer: "امیر هاشم نژاد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HadiseEshghAmirHashemNejad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HadiseEshghAmirHashemNejad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "همیشه عاشت خواهم ماند",
        duration: parseDuration("00:03:15"),
        singer: "بنیامین محمدی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HamisheAsheghatKhahamMandBenyaminMohammadi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HamisheAsheghatKhahamMandBenyaminMohammadi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "حس مشترک",
        duration: parseDuration("00:02:11"),
        singer: "بهنام خدارحمی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HesseMoshtarekBehnamKhodarahmi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HesseMoshtarekBehnamKhodarahmi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "حس متفاوت",
        duration: parseDuration("00:04:17"),
        singer: "امید آزادگان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HesseMotefavetOmidAzadegan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/HesseMotefavetOmidAzadegan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خاطره",
        duration: parseDuration("00:04:55"),
        singer: "مازیار بازگیر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhaterehMaziarBazgir.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhaterehMaziarBazgir.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خاتون",
        duration: parseDuration("00:04:41"),
        singer: "کیهان کلهر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhatoonKeyhanKalhor.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhatoonKeyhanKalhor.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خداحافظی",
        duration: parseDuration("00:04:04"),
        singer: "فرامرز فنونی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhodahafeziFaramarzFonooni.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhodahafeziFaramarzFonooni.mp3?host=dl.musiciom.ir",
      },
      {
        title: "خوب بد زشت",
        duration: parseDuration("00:02:17"),
        singer: "محمد تقاضایی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhoobBadZeshtMohammadTaghazaei.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/KhoobBadZeshtMohammadTaghazaei.mp3?host=dl.musiciom.ir",
      },
      {
        title: "لزگی",
        duration: parseDuration("00:02:25"),
        singer: "علی بهرامی فرد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/LezgiAliBahramiFard.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/LezgiAliBahramiFard.mp3?host=dl.musiciom.ir",
      },
      {
        title: "Melopee Pour Mathilde",
        duration: parseDuration("00:01:54"),
        singer: "امید آزادگان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/MelopeePourMathildeOmidAzadegan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/MelopeePourMathildeOmidAzadegan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "نوید یک موهبت الهی",
        duration: parseDuration("00:03:46"),
        singer: "نوسین بنار",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/navidyekmoohebatelahiNoshinBenar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/navidyekmoohebatelahiNoshinBenar.mp3?host=dl.musiciom.ir",
      },
      {
        title: "نوروز",
        duration: parseDuration("00:03:33"),
        singer: "مازیار بازگیر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/NorouzMaziarBazgir.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/NorouzMaziarBazgir.mp3?host=dl.musiciom.ir",
      },
      {
        title: "نوا",
        duration: parseDuration("00:02:25"),
        singer: "نگین محمدی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/NovaNeginMohammadi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/NovaNeginMohammadi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "پدر یک آغوش قلبی",
        duration: parseDuration("00:03:02"),
        singer: "بهنام خدارحمی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/PedareYekAghoosheGhalbiBehnamKhodarahmi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/PedareYekAghoosheGhalbiBehnamKhodarahmi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "رهایی",
        duration: parseDuration("00:04:02"),
        singer: "حامد قاسمی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/RayaeiHamedGhasemi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/RayaeiHamedGhasemi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "روایت یک زندگی",
        duration: parseDuration("00:03:58"),
        singer: "مازیار بازگیر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/RevayateYekZendegiMaziarBazgir.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/RevayateYekZendegiMaziarBazgir.mp3?host=dl.musiciom.ir",
      },
      {
        title: "رومبا",
        duration: parseDuration("00:03:05"),
        singer: "رامین مهاجر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/RombaRaminMohajer.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/RombaRaminMohajer.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ساعت صفر عاشقی",
        duration: parseDuration("00:04:40"),
        singer: "مازیار بازگیر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SaateSefreAsheghiMaziarBazgir.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SaateSefreAsheghiMaziarBazgir.mp3?host=dl.musiciom.ir",
      },
      {
        title: "سری گلین",
        duration: parseDuration("00:04:49"),
        singer: "افشین خواجه نژاد",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SariGelinAfshinKhajehNejad.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SariGelinAfshinKhajehNejad.mp3?host=dl.musiciom.ir",
      },
      {
        title: "سرزمین انار",
        duration: parseDuration("00:05:23"),
        singer: "حمیدرضا آفریده",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SarzamineAnarHamidrezaAfarideh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SarzamineAnarHamidrezaAfarideh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شباروز",
        duration: parseDuration("00:04:48"),
        singer: "صائب کاکاوند",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ShabaroozSaebKakavand.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ShabaroozSaebKakavand.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شبی حائل چنین در سیل",
        duration: parseDuration("00:03:46"),
        singer: "شاهین مهاجری",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ShabiHaelCheninDarseylShahinMohajeri.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ShabiHaelCheninDarseylShahinMohajeri.mp3?host=dl.musiciom.ir",
      },
      {
        title: "شمال",
        duration: parseDuration("00:02:48"),
        singer: "محمد کریم بخش",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ShomalMohammadKarimBakhsh.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ShomalMohammadKarimBakhsh.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ستون های آفرینش",
        duration: parseDuration("00:06:27"),
        singer: "شاهین مهاجری",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SotoonhayeAfarineshShahinMohajeri.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/SotoonhayeAfarineshShahinMohajeri.mp3?host=dl.musiciom.ir",
      },
      {
        title: "قدم های بدون تو",
        duration: parseDuration("00:03:06"),
        singer: "علی زرگری پور و علیرضا مهدیلو",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/StepsWithoutYouAliZargaripour.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/StepsWithoutYouAliZargaripour.mp3?host=dl.musiciom.ir",
      },
      {
        title: "تباهی",
        duration: parseDuration("00:04:39"),
        singer: "نوید کیارزم",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/TabahiNavidKiarazm.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/TabahiNavidKiarazm.mp3?host=dl.musiciom.ir",
      },
      {
        title: "ترمه",
        duration: parseDuration("00:03:07"),
        singer: "هیراد پناهی",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/TermehHiradPanahi.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/TermehHiradPanahi.mp3?host=dl.musiciom.ir",
      },
      {
        title: "طلوع آرامش",
        duration: parseDuration("00:03:30"),
        singer: "مازیار بازگیر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/TolooeArameshMaziarBazgir.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/TolooeArameshMaziarBazgir.mp3?host=dl.musiciom.ir",
      },
      {
        title: "والس بهار",
        duration: parseDuration("00:04:39"),
        singer: "امید آزادگان",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/WaltzeBaharOmidAzadegan.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/WaltzeBaharOmidAzadegan.mp3?host=dl.musiciom.ir",
      },
      {
        title: "زخم کاری * تیتراژ ابتدایی",
        duration: parseDuration("00:02:27"),
        singer: "حبیب خرایی فر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ZakhmeKariHabibKhazaeifar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ZakhmeKariHabibKhazaeifar.mp3?host=dl.musiciom.ir",
      },
      {
        title: "زخم کاری * تیتراژ انتهایی",
        duration: parseDuration("00:04:16"),
        singer: "حبیب خرایی فر",
        cover:
          "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ZakhmeKariTitrajePayaniHabibKhazaeifar.jpg?host=dl.musiciom.ir",
        src: "https://vod.dooorbin.ir/mp3/radiomusiciom/bikalam/ZakhmeKariTitrajePayaniHabibKhazaeifar.mp3?host=dl.musiciom.ir",
      },
    ],
  },
];
